/**
 * Шапка дашборда — приветствие, дата и 3-4 главных KPI:
 * открытые сделки, деньги в работе, непринятые лиды, конверсия.
 */

import { Inbox, Layers, Percent, Briefcase } from 'lucide-react'
import { KpiCard } from './primitives'
import { formatRub } from '@/lib/utils'
import type { Dashboard } from '@/types'

function greeting(): string {
  const h = new Date().getHours()
  if (h < 5) return 'Доброй ночи'
  if (h < 12) return 'Доброе утро'
  if (h < 18) return 'Добрый день'
  return 'Добрый вечер'
}

const FULL_DATE = new Intl.DateTimeFormat('ru-RU', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
})

export function HeaderKpis({ dashboard, name }: { dashboard: Dashboard; name: string }) {
  const totalOpen = dashboard.total_open_deals ?? (dashboard.no_next_step_deals ?? []).length
  const unclaimed = dashboard.counts?.unclaimed_leads ?? (dashboard.unclaimed_leads ?? []).length
  const pipeline = dashboard.money?.pipeline_value ?? null
  const conv = dashboard.funnel?.conversion_to_contract ?? null

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h1 className="text-xl font-semibold">
          {greeting()}
          {name ? `, ${name}` : ''}
        </h1>
        <p className="text-sm capitalize text-muted-foreground">{FULL_DATE.format(new Date())}</p>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <KpiCard
          label="Открытых сделок"
          value={totalOpen}
          icon={Briefcase}
          accent="primary"
        />
        <KpiCard
          label="Деньги в работе"
          value={pipeline != null ? formatRub(pipeline) : '—'}
          icon={Layers}
          accent="primary"
        />
        <KpiCard
          label="Непринятые лиды"
          value={unclaimed}
          icon={Inbox}
          accent={unclaimed > 0 ? 'red' : 'neutral'}
        />
        <KpiCard
          label="Конверсия в договор"
          value={conv != null ? `${Math.round(conv * 100)}%` : '—'}
          icon={Percent}
          accent={conv != null ? (conv >= 0.5 ? 'green' : conv >= 0.3 ? 'amber' : 'red') : 'neutral'}
        />
      </div>
    </div>
  )
}
